(function () {

    'use strict';

    angular.module('Services').factory('CarrierProfileTableService', CarrierProfileTableService);

    CarrierProfileTableService.$inject = ['Carrier', 'TableLiteFactory', '$location', 'toastr', 'PermissionHelpers', 'AdminPermissionService', '$rootScope'];

    function CarrierProfileTableService(Carrier, TableLiteFactory, $location, toastr, PermissionHelpers, AdminPermissionService, $rootScope) {
        return function (carriers) {
            var tableStructure = {
                tableName: 'CarrierProfilesTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary pull-left',
                        label: 'CREATE NEW PROFILE',
                        tooltip: 'Click to Create new Carrier Profile',
                        onClick: function () {
                            $location.path('/carriers/carrier-profiles/new')
                        }
                    }],

                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noTopOptions: false,
                    noFooter: false,
                    rowsUnclickable: false
                },
                headers: [{
                    label: 'PROFILE NAME',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: "CARRIER",
                    viewName: "carrierLogo",
                    filterName: "carrierId",
                    filter: {
                        type: "select2",
                        placeholder: "Search",
                        filterBy: 'id',
                        items: carriers,
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'EMAIL',
                    viewName: 'email',
                    filterName: 'email',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'PHONE',
                    viewName: 'phone',
                    filterName: 'phone1',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'WEBSITE',
                    viewName: 'website',
                    filterName: 'website',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'active',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Active', 'Inactive'],
                        onSelect: function (header) {
                            var filter = {};

                            if (header.filter.model == 'Active') {
                                filter[header.filterName] = true;
                            } else {
                                filter[header.filterName] = false;
                            }

                            sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Networking Enabled',
                    viewName: 'networkEffect',
                    filterName: 'networkEffectEnabled',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Enabled', 'Disabled'],
                        onSelect: function (header) {
                            var filter = {};

                            if (header.filter.model === 'Enabled') {
                                filter[header.filterName] = true;
                            } else {
                                filter[header.filterName] = false;
                            }

                            sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }],
                data: []
            };

            setIsHideRatesEngine();

            // add hide rates engine

            function setIsHideRatesEngine() {
                AdminPermissionService.AdminCurrentUser.getAdminUserDetails(success => {
                    const moduleAccess = [];
                    success.content.forEach(user => {
                        user.modules.forEach(module => {
                            moduleAccess.push(module.name);
                        });
                    });
                    const isHideRatesEngine = PermissionHelpers.isHideRatesEngine(moduleAccess);
                    if (!isHideRatesEngine) {
                        tableStructure.optionAddOns.switcher = {
                            viewOwnProfiles: true,
                            onChange: function (evt) {
                                let switcher = this;
                                if (switcher.viewOwnProfiles) {
                                    tableActions = originalTable;
                                }
                                else {
                                    tableActions = sharedTable;
                                }

                                initHandlers(tableActions);
                                tableActions.sendRequest();
                            },
                            trueLabel: 'MY CARRIER PROFILES',
                            falseLabel: 'NETWORK CARRIER PROFILES',
                        }
                        tableStructure.optionAddOns.wrapperClass = ''
                        tableStructure.optionAddOns.url = '/templates/pages/carriers/additionals/clientDropdown.html'
                    }

                }, error => { }, $rootScope.GlobalProfile.id);
            }

            const originalTable = new TableLiteFactory(tableStructure,
                {
                    serviceCallback: Carrier.getExternalCarrierProfiles,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'id,desc',
                        isOwned: true
                    }
                }
            );
            const sharedTable = new TableLiteFactory(tableStructure,
                {
                    serviceCallback: Carrier.getExternalCarrierProfiles,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'id,desc',
                        isOwned: false,
                        isConnected: true,
                        isResellerNetwork: true,
                        isReceived: true
                    }
                }
            );
            let tableActions = originalTable;
            let sort = null;
            let evaluateFilter = null;
            let sendRequest = null;

            initHandlers(tableActions);

            function initHandlers(actions) {
                sort = actions.sort;
                evaluateFilter = actions.evaluateFilter;
                sendRequest = actions.sendRequest;
            }

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (row, index) {
                    if (row.phone1 && row.phone2) {
                        row.phone = {
                            type: 'multiLine',
                            list: [row.phone1, row.phone2]
                        };
                    } else {
                        row.phone = row.phone1 || row.phone2 || 'N/A';
                    }
                    row.name = angular.getObjVal(row, 'displayName') ? row.displayName : row.name;
                    row.href = '/carriers/carrier-profiles/' + row.id;
                    row.status = {
                        type: 'status',
                        status: row.active,
                        label: row.active ? 'Active' : 'Inactive'
                    };
                    row.email = row.email || 'N/A';
                    row.website = row.website || 'N/A';
                    row.carrierLogo = {
                        imgSrc: row.logoUrl,
                        type: 'logotype'
                    };

                    row.networkEffect = {
                        type: 'status',
                        status: row.networkEffectEnabled,
                        label: row.networkEffectEnabled ? 'Enabled' : 'Disabled'
                    }
                    tableStructure.data.push(row);
                });
            }
            this.tableData = tableStructure;
        };
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/CarrierProfileTableService.js